import { MonthIcon, WeekIcon } from 'src/components/common/icons'
import { DayIcon } from 'labguard-cdk'

export const calendarModes = [
  {
    icon: MonthIcon,
    value: 'month',
  },
  {
    icon: WeekIcon,
    value: 'week',
  },
  {
    icon: DayIcon,
    value: 'day',
  },
]
